import { Typography, Container } from "@mui/material";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase.config";
import { toast } from "react-toastify";
import Spinner from "../components/Spinner";

import ShowTierListContainer from "../components/ShowTierListContainer";

function TierList() {
  const [loading, setLoading] = useState(true);
  const [tierList, setTierList] = useState({});
  const params = useParams();
  const auth = getAuth();

  useEffect(() => {
    const fetchTierList = async () => {
      try {
        // Get Reference
        const tierListRef = collection(db, "tierLists");

        // Create a query
        const queryString = params.tierListId;
        const q = query(tierListRef, where("__name__", "==", queryString));
        console.log(q);

        // Execute query
        const querySnap = await getDocs(q);

        // const lastVisible = querySnap.docs[querySnap.docs.length - 1];

        let tierListObject = {};

        querySnap.forEach((doc) => {
          return (tierListObject = {
            id: doc.id,
            data: doc.data(),
          });
        });
        setTierList((prevState) => ({ ...prevState, ...tierListObject }));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Could not fetch listings");
      }
    };

    fetchTierList();
  }, [params.tierListId]);

  return loading ? (
    <Spinner />
  ) : (
    <Container>
      <Typography variant="h1" component="h1">
        Welcome to TierList {tierList.data.titleName}
      </Typography>
      <Typography variant="h2" component="h2">
        Author: {tierList.data.author.id}
      </Typography>
      <ShowTierListContainer tierList={tierList} />
      {auth.currentUser?.uid === tierList.data.author.id && (
        <Link to={"/tierlist/edit/" + tierList.id}>Edit this listing</Link>
      )}
    </Container>
  );
}

export default TierList;
